import React, { Fragment, useEffect, useState } from 'react'
import { getCountryListMap } from 'country-flags-dial-code';
import Countries from '../Json/Countries.json';
import { HiChevronUpDown } from 'react-icons/hi2';
import { Listbox, Transition } from '@headlessui/react';
import { BsArrowRightShort } from 'react-icons/bs';

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const BusinessRepresent = ({ setStep, setMainStep, businessRepresent, setBusinessRepresent, isUpdate, setData }) => {
    const [countryFlagJson, setCountryFlagJson] = useState([])
    const [selected, setSelected] = useState('');
    const [security, setSecurity] = useState(false)
    const [countryName, setCountryName] = useState('')
    const [validName, setValidName] = useState('')
    const [validEmail, setValidEmail] = useState('')

    const getCountry = () => {
        const countryList = getCountryListMap()
        const countryValue = Object.values(countryList)
        setCountryFlagJson(countryValue)
        setSelected(Object.values(countryList)[232])
        setCountryName(Object.values(countryList))
    }

    const handleContinue = () => {
        if (!validation()) {
            if(isUpdate){
                setMainStep('step5');
                setStep('Summary');
                setData('default')
            } else {
                setStep('owners')
            }
        }
    }

    const validation = () => {
        let valid = false;
        if (businessRepresent.representative_first_name === "" || businessRepresent.representative_last_name === "") {
            setValidName("Please enter a first and last name.");
            valid = true;
        }
        if (businessRepresent.representative_email === "") {
            setValidEmail("Please enter an email address.");
            valid = true;
        }
        return valid;
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    useEffect(() => {
        getCountry()
    }, [])

    return (
        <div>
            <div>
                <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Verify your personal details</h3>
                <p className='text-[#414552] mt-2'>This account should be activated by someone authorized to sign on your organization’s behalf. If that’s not you, please ask the right person to complete this form.</p>
                <div className='sm:mt-[32px] mt-[25px]'>
                    <div>
                        <label htmlFor="legal-name" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Legal name</label>
                        <div className="relative mt-2 w-full">
                            <input
                                value={businessRepresent.representative_first_name}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_first_name: e.target.value})}
                                type='text' id="legal-name" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='First name' />
                            <input
                                value={businessRepresent.representative_last_name}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_last_name: e.target.value})}
                                type='text' id="legal-name" className="mt-2 input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Last name' />
                        </div>
                        <p className="text-red-600">{businessRepresent.representative_first_name === "" || businessRepresent.representative_last_name === "" ? validName : ""}</p>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px]'>
                        <label htmlFor="Email-address" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Email address</label>
                        <div className="relative mt-2 w-full">
                            <input
                                value={businessRepresent.representative_email}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_email: e.target.value})}
                                type='text' id="Email-address" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='you@example.com' />
                            <p className="text-red-600">
                                {businessRepresent.representative_email === "" ? validEmail : ""}
                                {businessRepresent.representative_email !== "" && !isValidEmail(businessRepresent.representative_email) ? "Please provide a valid email." : ""}
                            </p>
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px]'>
                        <label htmlFor="Job-title" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Job title</label>
                        <div className="relative mt-2 w-full">
                            <input
                                value={businessRepresent.representative_job_title}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_job_title: e.target.value})}
                                type='text' id="Job-title" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='CEO, Manager, Partner' />
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px]'>
                        <label htmlFor="DOB" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Date of birth</label>
                        <div className="relative mt-2 w-full">
                            <input
                                value={businessRepresent.representative_DOB}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_DOB: e.target.value})}
                                type='number' id="DOB" className="input_focus_shadow text-[#404452] px-3 w-max bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='DD / MM / YYYY' />
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label htmlFor="Home-address" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Home address
                        </label>
                        <div>
                            <div className="relative w-full mt-1">
                                <select id="Home-address" value={businessRepresent.representative_country} onChange={(e) => setBusinessRepresent({...businessRepresent, representative_country: e.target.value})} className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                    {Countries.slice(1).map((val, i) => {
                                        return (
                                            <option key={i} value={val.country}>{val.country}</option>
                                        )
                                    })}
                                </select>
                                <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                            </div>
                            <div className='mt-5'>
                                <input
                                    value={businessRepresent.representative_address1}
                                    onChange={(e) => setBusinessRepresent({...businessRepresent, representative_address1: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line1' />
                                <input
                                    value={businessRepresent.representative_address2}
                                    onChange={(e) => setBusinessRepresent({...businessRepresent, representative_address2: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line2' />
                                <input
                                    value={businessRepresent.representative_city}
                                    onChange={(e) => setBusinessRepresent({...businessRepresent, representative_city: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='City' />
                                <input
                                    value={businessRepresent.representative_zip}
                                    onChange={(e) => setBusinessRepresent({...businessRepresent, representative_zip: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Zip' />
                                <div className="relative w-full mt-2">
                                    <select value={businessRepresent.representative_state} onChange={(e) => setBusinessRepresent({...businessRepresent, representative_state: e.target.value})} id="country" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                        {Countries.map((val) =>
                                            businessRepresent.representative_country === val.country &&
                                            val.states.map((state, i) => <option key={i} value={state} > {state}</option>)
                                        )}
                                    </select>
                                    <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Business phone number</label>
                        <div className="rounded-[6px] mt-1 w-full input_focus_shadow flex items-center">
                            <Listbox value={selected} onChange={setSelected}>
                                {({ open }) => (
                                    <>
                                        <div className="relative">
                                            <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-7 text-left text-gray-900 focus:outline-none text-sm leading-6">
                                                <div className='adjust-flag' dangerouslySetInnerHTML={{ __html: selected.flag }}></div>
                                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                                    <HiChevronUpDown className="text-[18px]" />
                                                </span>
                                            </Listbox.Button>

                                            <Transition
                                                show={open}
                                                as={Fragment}
                                                leave="transition ease-in duration-100"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                            >
                                                <Listbox.Options className="absolute sm:w-[400px] xs:w-[350px] w-[270px] z-[100] mt-1 max-h-60 overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 shadow-xl focus:outline-none text-sm">
                                                    {countryFlagJson.map((person, i) => (
                                                        <Listbox.Option
                                                            key={i}
                                                            className={({ active }) =>
                                                                classNames(
                                                                    active
                                                                        ? "bg-[#f6f8fa]"
                                                                        : "text-[#414552]",
                                                                    "relative cursor-default select-none py-2 px-3"
                                                                )
                                                            }
                                                            value={person}
                                                        >
                                                            {({ selected, active }) => (
                                                                <>
                                                                    <div className='flex items-center justify-between'>
                                                                        <div className='flex gap-3 items-center'>
                                                                            <div className='adjust-flag' dangerouslySetInnerHTML={{ __html: person.flag }}></div>
                                                                            <span
                                                                                className={classNames(
                                                                                    selected
                                                                                        ? "font-semibold"
                                                                                        : "font-normal",
                                                                                    "block truncate"
                                                                                )}
                                                                            >
                                                                                {person.country}
                                                                            </span>
                                                                        </div>
                                                                        <span className='text-[#687385] text-sm'>{person.dialCode}</span>
                                                                    </div>

                                                                    {selected ? (
                                                                        <span
                                                                            className={classNames(
                                                                                active
                                                                                    ? "text-white"
                                                                                    : "text-indigo-600",
                                                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                                                            )}
                                                                        ></span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                            </Transition>
                                        </div>
                                    </>
                                )}
                            </Listbox>
                            <div className='text-sm pl-2 text-[#414552]'>{selected.dialCode}</div>
                            <input
                                value={businessRepresent.representative_phone_number}
                                onChange={(e) => setBusinessRepresent({...businessRepresent, representative_phone_number: e.target.value})}
                                type='number' placeholder='(201) 555-0123' id="Company-identification" className="text-[#404452] rounded-[6px] px-3 w-full bg-white font-normal focus:outline-none h-[36px] py-1 text-[14px]" />
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        {security ?
                            <>
                                <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Social Security number</label>
                                <div className="rounded-[6px] mt-1 w-full input_focus_shadow flex items-center">
                                    <div className="relative max-w-[55px] w-full">
                                        <select defaultValue="US" className="text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                            {countryName.map((val, i) => {
                                                return (
                                                    <option key={i} value={val.code}>{val.code}</option>
                                                )
                                            })}
                                        </select>
                                        <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[22px]" />
                                    </div>
                                    <input
                                        value={businessRepresent.representative_phone_number}
                                        onChange={(e) => setBusinessRepresent({ ...businessRepresent, representative_phone_number: e.target.value })}
                                        type='number' placeholder='(201) 555-0123' className="text-[#404452] rounded-[6px] px-3 w-full bg-white font-normal focus:outline-none h-[36px] py-1 text-[14px]" />
                                </div>
                                <p className='text-sm text-[#414552] mt-2'>To verify your identity, we’ll need to know your full Social Security number.</p>
                            </> :
                            <>
                                <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Last 4 digit of Social Security number</label>
                                <div className="relative mt-2 gap-1 flex items-center px-3 border-[1px] max-w-[128px] rounded-[6px] w-full border-[#e0e1e3] text-[#404452]">
                                    <span className='whitespace-nowrap'>••• – •• –</span>
                                    <input
                                        value={businessRepresent.representative_social_sequrity_number}
                                        onChange={(e) => setBusinessRepresent({ ...businessRepresent, representative_social_sequrity_number: e.target.value })}
                                        type='text' className="pl-1 w-full bg-white font-normal focus:outline-none h-[36px] py-1 text-[14px]" placeholder='1234' />
                                </div>
                                <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                                    <p className='text-sm text-[#414552]'>The last 4 digits of your SSIN are only used to verify your indentify-no credit checks.</p>
                                </div>
                            </>
                        }
                        <button onClick={() => setSecurity(!security)} className='text-sm font-semibold text-[#625afa]'>
                            {security ? "Provide last 4 digits of Social Security number instead" : "Provide a government-issued IO number instead"}
                        </button>

                    </div>
                    <div className='mt-6 pb-5'>
                        <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue<BsArrowRightShort className='text-[25px]' /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessRepresent